import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@material-ui/core';


const ageMapping = {
  lessThan30: 'poniżej 30 lat',
  between3145: 'od 31 do 45 lat',
  between4660: 'od 46 do 60 lat',
  greaterThan60: 'powyżej 60 lat',
};

const VoterDataReadOnly = ({ voterData }) => {
  const renderField = (label, value) => {
    return value ? (
      <Grid item xs={6}>
        <Typography variant="body1"><strong>{label}:</strong> {value}</Typography>
      </Grid>
    ) : null;
  };

  return (
    <div>
      <Grid container spacing={1}>
        {renderField('Imię', voterData.firstName)}
        {renderField('Drugie imię', voterData.secondName)}
        {renderField('Nazwisko', voterData.lastName)}
        {renderField('Adres', voterData.address)}
        {renderField('Numer', voterData.number)}
        {renderField('Numer lokalu', voterData.localNumber)}
        {renderField('Kod pocztowy', voterData.zipCode)}
        {renderField('Miasto', voterData.city)}
        {renderField('Data urodzenia', voterData.birthDate)}
        {renderField('Miejsce urodzenia', voterData.birthPlace)}
        {renderField('Imię matki', voterData.motherName)}
        {renderField('Imię ojca', voterData.fatherName)}
        {renderField('Nazwisko rodowe matki', voterData.motherLastName)}
        {renderField('Obywatelstwo', voterData.citizenship)}
        {renderField('Pesel', voterData.pesel)}
        {renderField('Numer PESEL - wybrane cyfry', voterData.peselFragment)}
        {renderField('Numer karty', voterData.cityCard)}
        {renderField('Numer telefonu', voterData.phoneNumber)}
        {renderField('Adres e-mail', voterData.email)}
        {renderField('Płeć', voterData.gender)}
        {renderField('Wiek', voterData.age ? ageMapping[voterData.age] : null)}
        {renderField('Status zawodowy', voterData.status)}
      </Grid>
    </div>
  );
};

VoterDataReadOnly.propTypes = {
  voterData: PropTypes.shape({
    city: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    secondName: PropTypes.string,
    lastName: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    localNumber: PropTypes.string,
    zipCode: PropTypes.string.isRequired,
    birthDate: PropTypes.string,
    birthPlace: PropTypes.string,
    motherName: PropTypes.string,
    fatherName: PropTypes.string,
    motherLastName: PropTypes.string,
    citizenship: PropTypes.string,
    pesel: PropTypes.string,
    peselFragment: PropTypes.string,
    cityCard: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    gender: PropTypes.string,
    age: PropTypes.string.isRequired,
    status: PropTypes.string,
  }).isRequired,
};

export default VoterDataReadOnly;


// WEBPACK FOOTER //
// ./src/components/budget/VoterDataPreview.js